import { createIFrame } from "@/Pages/Cases/functions/createIFrame";

export const openPrintCasePDFDialog = ({
  caseId,
  caseReportPDFObjectURL,
}: {
  caseId: string;
  caseReportPDFObjectURL: string;
}): void => {
  const pdfIFrame = createIFrame({ id: caseId, source: caseReportPDFObjectURL });

  if (pdfIFrame?.contentWindow) {
    pdfIFrame.contentWindow.print();
  }

  setTimeout(function () {
    pdfIFrame?.remove();
  }, 600000);
};
